import { useEffect } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { MotionGrid as Grid, staggeredAppear, appearBelow } from "utils/motion";
import Text from "components/base/Text";
import Image from "components/base/Image";
import Container from "components/base/Container";

export default function DiagramSection({
  title,
  subtitle,
  image,
  step1,
  step2,
  step3,
}) {
  useEffect(() => {
    const isiOS = /^iP/.test(navigator.platform);
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.defaults({
      toggleActions: "restart pause resume pause", // Scoll effect Forward, Leave, Back, Back Leave
      markers: false,
    });

    if (isiOS) {
      ScrollTrigger.config({
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
      });
    }
    const timeline = gsap.timeline({
      scrollTrigger: {
        id: "diagram-section-animation",
        trigger: "#box-diagram-section",
        scrub: 1,
        snap: {
          snapTo: "labels", // snap to the closest label in the timeline
          duration: { min: 0.2, max: 2 },
        },
        start: "center 50%",
        end: "bottom -50%",
        pin: true,
      },
    });

    timeline
      .addLabel("start")
      .to("#text1-diagram-section", { opacity: 1, y: -30 })
      .addLabel("text1")
      .to("#text2-diagram-section", { opacity: 1, y: -30 })
      .addLabel("text2")
      .to("#text3-diagram-section", { opacity: 1, y: -30 })
      .addLabel("text3");
  }, []);

  return (
    <Box width="100%" bg="white">
      <Container small textAlign="center">
        <Grid
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          width="100%"
          templateColumns="1fr"
        >
          <Text
            type="headline_md"
            variants={appearBelow}
            mb={[2, null, 6]}
            color="black.700"
          >
            {title}
          </Text>
          <Text type="p_md" color="black.700" variants={appearBelow}>
            {subtitle}
          </Text>
          <Box id="box-diagram-section">
            <Image src={image} height={["250px", null, "475px"]} />
            <Grid templateColumns={["1fr", null, "repeat(3, 1fr)"]} gap={6}>
              <Flex
                alignItems="flex-start"
                id="text1-diagram-section"
                opacity={0}
              >
                <Text type="title_lg" color="primary">
                  1
                </Text>
                <Text type="p_sm" color="black.700" align="left" ml="sm">
                  {step1}
                </Text>
              </Flex>
              <Flex
                alignItems="flex-start"
                id="text2-diagram-section"
                opacity={0}
              >
                <Text type="title_lg" color="primary">
                  2
                </Text>
                <Text type="p_sm" color="black.700" align="left" ml="sm">
                  {step2}
                </Text>
              </Flex>
              <Flex
                alignItems="flex-start"
                id="text3-diagram-section"
                opacity={0}
              >
                <Text type="title_lg" color="primary">
                  3
                </Text>
                <Text type="p_sm" color="black.700" align="left" ml="sm">
                  {step3}
                </Text>
              </Flex>
            </Grid>
          </Box>
        </Grid>
      </Container>
    </Box>
  );
}
